"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "chiavenna": {
    "194b312d": [{
      "hkey": "90ecce6c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "bette": [{
      "hkey": "90ecce6c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6c72cf85": [{
      "hkey": "8eedc211",
      "slug": "campedello-san-carlo",
      "name": "Campedello-San Carlo",
      "primary": true,
      "skipSearch": false
    }],
    "campedello": [{
      "hkey": "8eedc211",
      "slug": "campedello-san-carlo",
      "name": "Campedello-San Carlo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "540e950f": [{
      "hkey": "9e87b6bd",
      "slug": "chiavenna",
      "name": "Chiavenna",
      "primary": true,
      "skipSearch": false
    }],
    "loreto": [{
      "hkey": "9e87b6bd",
      "slug": "chiavenna",
      "name": "Chiavenna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "418a965e": [{
      "hkey": "8eedc211",
      "slug": "campedello-san-carlo",
      "name": "Campedello-San Carlo",
      "primary": true,
      "skipSearch": false
    }],
    "san-carlo": [{
      "hkey": "8eedc211",
      "slug": "campedello-san-carlo",
      "name": "Campedello-San Carlo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chiavenna"
    }],
    "d87defc8": [{
      "hkey": "90ecce6c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "90ecce6c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chiavenna"
    }],
    "9f4cd9d0": [{
      "hkey": "90ecce6c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "tanno": [{
      "hkey": "90ecce6c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chiavenna"
    }]
  }
};
exports["default"] = _default;